/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneNotesSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-NOTES-001
 * PURPOSE: Full note thread in a sheet. Pads for the iOS keyboard via visualViewport.
 */
import { useEffect, useState } from 'react'
import { MobileSheet, QaNoteThread, type QaNote } from '@quotech/ui'
import { QA_PHONE_CONTROLS } from '../qaPhoneControlInventory'

export function QaPhoneNotesSheet({
  open,
  onClose,
  notes,
  checkName,
  onAdd,
  onDelete,
}: {
  open: boolean
  onClose: () => void
  notes: QaNote[]
  checkName?: string
  onAdd: (text: string) => Promise<void>
  onDelete: (id: string) => Promise<void>
}) {
  const [kbPad, setKbPad] = useState(0)
  useEffect(() => {
    const view = window.visualViewport
    if (!view) return undefined
    const update = () => {
      setKbPad(Math.max(0, window.innerHeight - view.height - view.offsetTop))
    }
    view.addEventListener('resize', update)
    view.addEventListener('scroll', update)
    update()
    return () => {
      view.removeEventListener('resize', update)
      view.removeEventListener('scroll', update)
    }
  }, [])

  return (
    <MobileSheet open={open} onClose={onClose} title={checkName ? `Notes · ${checkName}` : 'Notes'} size="full">
      <div
        data-qa-phone-control={QA_PHONE_CONTROLS.notesThread}
        className="px-4 py-3 [&_textarea]:text-base"
        style={{ paddingBottom: kbPad }}
      >
        <QaNoteThread
          notes={notes}
          onAdd={onAdd}
          onDelete={onDelete}
          emptyLabel="No notes on this check yet."
        />
      </div>
    </MobileSheet>
  )
}
